<template>
  <van-popup
    v-model="showSwitch"
    position="bottom"
    class="shop_car_container"
    @close="closeHandle"
  >
    <safe-area>
      <template slot="container">
        <div class="shop_car_content">
          <div class="product-info">
            <img :src="courseImg" alt="" class="product-img" @click="handleShowImage"/>
            <div class="intro-wrap">
              <p class="title">{{ detail.name }}</p>
              <p class="desc" v-if="!isPhysicalGoods">{{ detail.goodsDesc }}</p>
              <template v-if="isPhysicalGoods && !disabled">
                <p class="desc">已选：{{ upspecilName }} {{ downspecilName }}</p>
                <p class="desc" style="font-size: 14px;">￥{{ aucPtPrice }}</p>
              </template>
            </div>
            <div class="del_wrap_out">
              <i-del-tag @click.native="onClose" />
            </div>
          </div>

          <!-- 有规格 -->
          <template v-if="isShowSpecil">
            <!-- 单规格 -->
            <div class="sku-wrap sku-wrap1" :style="(groupBuyMark && (ptFlagProp === 1 || ptFlag == 1) && ptLadderList.length > 1) ? {} : {marginBottom: '40px'}" v-if="!this.ifDoubleSku">
              <div
                class="sku-outeritem-wrap"
                v-for="(item1, index1) in skuRenderArr"
                :key="index1"
              >
                <div class="sku-title">{{ item1.specilName }}</div>
                <div class="sku-inneritem-wrap clearfix" :class="{'sku-inneritem-wrap--phy': isPhysicalGoods}">
                  <div
                    class="sku-inner-item"
                    v-for="(item2, index2) in item1.specilArr"
                    :key="index2"
                  >

                    <div class="item-wrap item2-wrap" :class="{'item-wrap--selected': item2.selected}">
                      <div v-if="isPhysicalGoods && item2.coverImg" class="item-wrap__cover" @click="handleSkuClick(item2, index1, index2)">
                        <img class="item-wrap__cover-img" :src="item2.coverImg" alt="">
                      </div>
                      <p
                        :class="`item-name ${item2.selected ? 'selected' : ''}`"
                        @click="handleSkuClick(item2, index1, index2)"
                      >
                        {{ item2.specilName }}
                      </p>
                      <div
                        v-if="item2.stockTips !== ''"
                        :class="`stock-bg ${item2.selected ? 'selected' : ''}`"
                        :style="`background:url('${
                          item2.selected ? stockBgArr[1] : stockBgArr[0]
                        }') no-repeat center `"
                      >
                        {{ item2.stockTips }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 数量 -->
              <div class="physical-num" v-if="isPhysicalGoods" >
                <span> <b>数量</b> </span>
                <num-counter
                  :min="1"
                  :max="limitNum.stockNum || 999"
                  :numCounter="numCount"
                  @add="numAdd"
                  @minus="numMinus"
                  :inputDisable="true"
                  @inputClick="inputNumClick"
                ></num-counter>
              </div>
            </div>

            <!-- 双规格 -->
            <div class="sku-wrap sku-wrap2" :style="(groupBuyMark && (ptFlagProp === 1 || ptFlag == 1) && ptLadderList.length > 1) ? {} : {marginBottom: '40px'}" v-else>
              <div
                class="sku-outeritem-wrap"
                v-for="(item1, index1) in skuRenderArr"
                :key="index1"
              >
                <template v-if="item1.isModuleShow">
                  <div :class="`sku-title ${index1 === 0 ? '' : 'sku-title2'}`">
                    {{ item1.specilName }}
                  </div>
                  <div class="sku-inneritem-wrap clearfix">
                    <div
                      class="sku-inner-item"
                      v-for="(item2, index2) in item1.specilArr"
                      :key="index2"
                    >
                      <div
                        v-if="item2.display"
                        :class="`item-wrap ${index1 === 1 ? 'item2-wrap' : ''}`"

                      >
                        <p
                          :class="`item-name ${item2.selected ? 'selected' : ''}`"
                          @click="handleSkuClick(item2, index1, index2)"
                        >
                          {{ item2.specilName }}
                        </p>
                        <div
                          v-if="item2.stockTips !== ''"
                          :class="`stock-bg ${item2.selected ? 'selected' : ''}`"
                          :style="`background:url('${
                            item2.selected ? stockBgArr[1] : stockBgArr[0]
                          }') no-repeat center `"
                        >
                          {{ item2.stockTips }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div v-else class="sku-wrap sku-wrap-nodata">
            已售罄，暂时无法购买
          </div>

          <div v-if="isShowSpecil" class="footer-wrap">
            <div class="pre_top_line" v-if="groupBuyMark && (ptFlagProp === 1 || ptFlag == 1) && ptLadderList && ptLadderList.length > 1"></div>
            <div class="top_line" v-if="groupBuyMark && (ptFlagProp === 1 || ptFlag == 1) && ptLadderList && ptLadderList.length > 1">
              <span v-for="item in ptLadderList" :key="item.idStr" :style="selectedPtLadder.idStr === item.idStr ? {color: '#FF5F2E', background: 'rgba(255,95,46,0.07)', fontWeight: 600} : {}" @click="selectedLadderClick(item)">{{item.ladderMembersNum}}人团</span>
            </div>
            <div class="middle_line" v-if="groupBuyMark && (ptFlagProp === 1 || ptFlag == 1) && ptLadderList && ptLadderList.length > 1"></div>
            <div class="bottom_line">
              <div v-if="!isBigButton" class="price-wrap" :style="showPriceLine ? {} : { visibility: 'hidden' }">
                <div class="actual-price" v-show="detail.showActualPrice">
                  <!-- <span v-if="groupBuyMark || (!detail.couponUse && couponUseMark)" class="group-buy-tip">{{groupBuyMark ? '拼团价' : '券后价'}}</span> -->
                  <span v-if="groupBuyMark || (!detail.couponUse && couponUseMark && couponUseText)" class="group-buy-tip">{{ groupBuyMark ? '拼团价' : couponUseText }}</span>
                  <span style="font-size: 14px; color:#41414D;" v-if="isPhysicalGoods">合计：</span>
                  <span class="icon">￥</span>
                  <span v-if="isPhysicalGoods" >{{ phyTotalPrice }}</span>
                  <template v-else>
                    <span class="price">{{ realPrice.actualPrice[0] }}</span>
                    <span class="price small">.{{ realPrice.actualPrice[1] }}</span>
                  </template>
                </div>
                <div class="original-price" v-if="showLinePrice() || detail.goodsType == 7">¥{{ realPrice.originalPrice }}</div>
              </div>
              <i-button
                :style="disabled || isOutSale ? 'opacity:0.4; white-space: pre-line; font-weight: normal;': 'white-space: pre-line; font-weight: normal;'"
                :size="isBigButton ? 'large' : 'normal'"
                :text="groupBuyMark ? aucPtPrice == '0.00' ? '确认' : '拼团购买' : (bottomButtonText || buyTxt)"
                v-log:click="{ name: '立即购买（内）' }"
                @i-click="addHandle"
              />
            </div>
          </div>
        </div>

        <!-- 实物输入数量弹窗 -->
        <NumChange :show="inputNumShow" :originNum="inputPopNum" @inputNumClose="inputNumClose" @numConfirm="numConfirm"  />
      </template>
    </safe-area>
  </van-popup>
</template>

<script>
import { getBuyNum } from '@/api/goods';
import { IDelTag } from '@/components/ITag';
import { IButton } from '@/components/IButton';
import { env, LogTrack, sub, JS2Native, isInBaidu, mul } from '@utils';
import mixin from '@/mixin/auth';
import { getUser, setUser } from '@utils/auth';
import { isDouyinApp, ISession } from '@utils';
import { douyinAuth } from '@utils/douyinAuth';
import SafeArea from '@/components/SafeArea';
import { ImagePreview } from 'vant';
import numCounter from '@components/numCounter/phyIndex';
import NumChange from '@/components/INumChange';
const isInBaiduBrowser = isInBaidu();

export default {
  name: 'shop-car-v2',
  mixins: [mixin],
  // 是否显示划线价格0: 否， 1: 是
  inject: ['showLinePrice'],
  props: {
    itemId: [Number, String],
    buyType: String,
    userReallyOnline: Boolean,
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    ptMaidian: {
      type: Object,
      default() {
        return {};
      },
    },
    show: Boolean,
    otherQuery: Object,
    bottomButtonText: String,
    showPriceLine: {
      type: Boolean,
      default: true
    },
    groupBuyMark: Boolean,
    ptActualPrice: String,
    ptLadderList: {
      type: Array,
      default() {
        return [];
      }
    },
    ptFlagProp: Number,
    fqBuyMark: Boolean,
    proxyInfo: Object
  },
  data() {
    let {
      instructor,
      itemid,
      preset_up_specil_id,
      igc_from,
      ptFlag,
      activityId
    } = this.$route.query;
    if (igc_from === 'xxx') {
      igc_from = undefined;
    }
    return {
      realPrice: {
        actualPrice: [undefined, undefined],
        originalPrice: undefined,
      },
      stockBgArr: [
        require('../images/0stockbg.png'),
        require('../images/1stockbg.png'),
      ],
      igc_from,
      preset_up_specil_id,
      upspecilName: '',
      downspecilName: '',
      goods: [],
      isShow: false,
      originalPrice: '',
      actualPrice: '',
      showSwitch: false,
      selectmaping: undefined,
      upSpecilId: null,
      downSpecilId: null,
      skuRenderArr: [{}],
      upSpecilData: [],
      downSpecilData: [],
      currentCourse: {},
      keysStr: '',
      upStr: '',
      downStr: '',
      upIndex: -1,
      downIndex: -1,
      stockNum: 0,
      instructor,
      itemid,
      selectedPtLadder: {},
      ptFlag,
      activityId,
      groupBuyMarkCount: 0,
      couponUseMark: false,
      specilHistoryObj: {},   // 记录选择的规格历史
      currentCourseImg: '',   // 实物商品当前规格封面图
      goodsCovers: [],         // 所有的规格图片
      inputNumShow: false,   // 是否显示数量输入框
      inputPopNum: 1,      // 弹窗的数值
      numCount: 1,         // 具体数量
      limitNum: {},        // 限购数量
      couponUseText: '',   // 优惠描述
    };
  },
  computed: {
    getCouponBuyPrice() {
      let {
        showActualPrice,
        couponInfoDetail,
        reduceFlag,
        reducePrice
      } = this.detail;
      if (this.selectmaping) {
        showActualPrice = this.selectmaping.actualPrice;
      }
      if (this.userReallyOnline) {
        if (reduceFlag) {
          if (showActualPrice - reducePrice >= 0) {
            showActualPrice = showActualPrice - reducePrice;
          }
        }
      }
      if (this.detail.couponUse) {
        showActualPrice = showActualPrice - couponInfoDetail.fullMoneyReduce;
        showActualPrice = +showActualPrice;
        showActualPrice = showActualPrice.toFixed(2);
        showActualPrice = showActualPrice <= 0 ? '0' : showActualPrice;
      }
      return showActualPrice;
    },
    ifDoubleSku() {
      return this.detail.downSpecil && this.detail.downSpecil.length > 0;
    },
    ifDoubleSkuSelect() {
      return this.upIndex >= 0 && this.downIndex >= 0;
    },
    price() {
      const detail = this.detail;
      const course = this.currentCourse;
      return {
        originalPrice: course.originalPrice || detail.showOriginalPrice,
        actualPrice: course.actualPrice || detail.showActualPrice,
      };
    },
    reducePrice() {
      if (this.detail.reduceFlag) {
        const result = sub(this.price.actualPrice, this.detail.reducePrice);
        return result > 0 ? result.toFixed(2) : '0.00';
      }
      return '0.00';
    },
    disabled() {
      let localDisabled = false;
      if (this.ifDoubleSku) {
        localDisabled = !this.ifDoubleSkuSelect;
      } else {
        localDisabled = this.upIndex < 0;
      }

      return localDisabled;
    },
    // 是否超买了
    isOutSale() {
      return this.detail.goodsType == 6 && this.limitNum.stockNum == 0;
    },
    buyTxt() {
      let text = '立即购买';
      if (this.detail && this.detail.couponUse && !this.activityId) {
        text = `￥${this.getCouponBuyPrice}\n${this.detail.ifReceived ? '用券' : '领券'}购买`;
      }
      // 如果是实物商品，且有自定义按钮文案，展示自定义按钮文案
      if (this.isPhysicalGoods && this.detail.btnText) {
        text = this.detail.btnText;
      }
      // 如果是0元简化流程， 默认 0元领取
      if (this.isSimpleProcess) {
        text = this.detail.btnText || '0元领取';
      }
      return text;
    },
    courseImg() {
      if (this.isPhysicalGoods && this.currentCourseImg) {
        return this.currentCourseImg;
      }
      return this.detail.coverImg || '';
    },
    // 是否展示规格
    isShowSpecil() {
      return this.skuRenderArr?.[0].specilArr?.length;
    },
    // 实际拼团价格
    aucPtPrice() {
      return this.realPrice.actualPrice[0] + '.' + this.realPrice.actualPrice[1];
    },
    // 是否是实物商品
    isPhysicalGoods() {
      return this.detail.goodsType == 6;
    },
    // 实物商品价格总计
    phyTotalPrice() {
      let price = mul(this.aucPtPrice, this.numCount);
      return price.toFixed(2);
    },
    // 是否是简化0元领取流程
    isSimpleProcess() {
      return this.detail.isSimplifyFlow && !this.ptFlag;
    },
    // 是否展示大按钮
    isBigButton() {
      return this.isSimpleProcess;
    },
  },
  created() {
  },
  watch: {
    show(a) {
      this.showSwitch = a;
    },
    groupBuyMark(v) {
      this.handleRealPrice();
    },
    detail() {
      let {
        upSpecilName,
        upSpecil,
        downSpecil,
        downSpecilName,
        specilMapping,
        goodsType
      } = this.detail;
      if (!upSpecil) {
        return [{}, {}];
      }

      this.detail.specilMapping = specilMapping.map((item) => {
        item.actualPrice = +item.actualPrice;
        item.originalPrice = +item.originalPrice;
        return item;
      });
      this.detail.reducePrice = +this.detail.reducePrice;
      // this.detail.skuSwitch = 1

      let goodsCovers = [this.detail.coverImg];
      // 如果某个up下面所有down都没有库存，责过滤掉当前up
      upSpecil = upSpecil.filter((item1, index) => {
        let specilId = item1.specilId;
        if ((!downSpecil || !downSpecil.length) && goodsType == 6) {
          // 只有一层规格时，将规格图片赋值到上规格中
          const r = specilMapping.find(item => item.key.includes(specilId));
          let ci = r.coverImg || '';
          if (r) {
            // 防止有相同地址图片
            ci += `${ci.indexOf('?') > -1 ? '&' : '?'}index=${index}`;
            item1.coverImg = ci;
            goodsCovers.push(ci);
          }
        }
        return specilMapping.find((item2) => {
          return item2.key.includes(specilId) && item2.stockNum > 0;
        });
      });
      this.goodsCovers = goodsCovers;

      /**
       * specilName: 上规格名称
       * specilArr: 上规格数组
       * isModuleShow: 模块是否显示
       */
      let arr = [{ specilName: upSpecilName, specilArr: upSpecil, isModuleShow: true }];
      if (this.ifDoubleSku) {
        arr.push({ specilName: downSpecilName, specilArr: downSpecil, isModuleShow: this.detail.skuSwitch == 1 ? true : false });
      }
      /**
       * 0 - 默认不选中（每一层都需要用户自己选择）
       * 1 - 默认选中（第一层推荐第一个规格，第二层推荐库存最多的规格）
       * 2 - 默认选中第二层（第一层需要用户选择，第二层需要推荐库存最多的规格
       */
      if (this.detail.skuSwitch == 1) {
        this.handlePreset(arr, upSpecil[0]?.specilId);
      }

      this.skuRenderArr = arr;
      this.handleRealPrice();

    },
  },

  methods: {
    selfUse() {
      let {
        upSpecilName,
        upSpecil,
        downSpecil,
        downSpecilName,
        specilMapping,
      } = this.detail;
      if (!upSpecil) {
        return [{}, {}];
      }
      this.detail.specilMapping = specilMapping.map((item) => {
        item.actualPrice = +item.actualPrice;
        item.originalPrice = +item.originalPrice;
        return item;
      });
      this.detail.reducePrice = +this.detail.reducePrice;

      // 如果某个up下面所有down都没有库存，责过滤掉当前up
      upSpecil = upSpecil.filter((item1) => {
        let specilId = item1.specilId;
        return specilMapping.find((item2) => {
          return item2.key.includes(specilId) && item2.stockNum > 0;
        });
      });

      let arr = [{ specilName: upSpecilName, specilArr: upSpecil, isModuleShow: true }];
      if (this.ifDoubleSku) {
        arr.push({ specilName: downSpecilName, specilArr: downSpecil, isModuleShow: this.detail.skuSwitch == 1 ? true : false });
      }

      this.handlePreset(arr, this.detail.skuSwitch == 1 ? upSpecil[0].specilId : '');

      this.handleRealPrice();
    },
    selectedLadderClick(item) {
      this.selectedPtLadder = item;
      this.handleRealPrice();

      this.$parent && this.$parent.setLogTrack && this.$parent.setLogTrack({ module_name: '拼团阶梯', btn_name: '拼团阶梯',  key1: {
        pt_ladder_id: item.idStr,
        pt_ladder_name: item.ladderName,
      } }, 'click');
    },
    handleRealPrice(index) {

      //  处理购物车价格显示
      let {
        selectmaping,
        detail: { specilMapping, reduceFlag, reducePrice },
      } = this;
      let needReduce = this.buyType === 'singBuy' && reduceFlag;
      let actualPrice, originalPrice;

      if (this.ptFlag && this.groupBuyMark) {
        if (!this.selectedPtLadder.idStr) {
          let tempArr = Object.assign([], this.ptLadderList);
          tempArr.sort((a, b) => {
            return a.ladderPrice - b.ladderPrice;
          });
          this.selectedPtLadder = tempArr[0] || {};
        }
        actualPrice = this.ptActualPrice || this.selectedPtLadder.ladderPrice;
        if (selectmaping) {
          originalPrice = selectmaping.originalPrice;
        } else {
          originalPrice = specilMapping[0].originalPrice;
        }
      } else {
        if (selectmaping) {
          actualPrice = selectmaping.actualPrice;
          originalPrice = selectmaping.originalPrice;
        } else {
          actualPrice = specilMapping[0].actualPrice;
          originalPrice = specilMapping[0].originalPrice;
        }
      }
      if (needReduce && !this.groupBuyMark) {
        actualPrice -= reducePrice;
        actualPrice = actualPrice.toFixed(2);
        if (actualPrice < 0) {
          actualPrice = '0.00';
        }
      } else {
        actualPrice = parseFloat(actualPrice).toFixed(2);
      }
      if (!this.detail.couponUse && this.detail.skuCouponMapping && !this.groupBuyMark) {
        if (this.selectmaping && this.detail.showCouponPrice) {
          actualPrice = actualPrice - this.detail.skuCouponMapping[this.selectmaping.skuId].discountPrice;
          actualPrice = parseFloat(actualPrice).toFixed(2);
        }
      }

      // 课包类型商品读取课包的价格
      if (this.detail.goodsType == 7 && this.detail.packageSkuInfos.length && selectmaping) {
        this.detail.packageSkuInfos.forEach(it => {
          if (it.id == selectmaping.skuId) {
            actualPrice = parseFloat(it.actualPrice).toFixed(2);
            originalPrice = parseFloat(it.originalPrice).toFixed(2);
          }
        });
      }

      actualPrice = actualPrice > 0 ? actualPrice : '0.00';
      this.realPrice = {
        actualPrice: [
          this.setPrice(actualPrice, 0),
          this.setPrice(actualPrice, 1),
        ],
        originalPrice: originalPrice,
      };
    },
    handlePreset(skuRenderArr, specialId) {
      // sku的上下规格数组
      this.skuRenderArr = skuRenderArr;
      let preset_up_specil_id = this.preset_up_specil_id || specialId;
      let upRenderArr = skuRenderArr[0].specilArr;
      // 选中的上规格
      upRenderArr.map((item, index) => {
        if (item.specilId === preset_up_specil_id) {
          this.handleSkuClick(item, 0, index, true);
        }
      });
    },
    /**
     *
     * @param {*} item 选中的规格信息
     * @param {*} index1 this.skuRenderArr 有两个对象  index1==0 代表上规格信息  index1 == 1代表下规格信息
     * @param {*} index2 this.skuRenderArr[index1].specilArr  数组下的具体下标值
     * @param {*} eventFalse  貌似是埋点所需 还不知道啥意思
     * @param {*} firstEnter  首次进入 初始化数据是否默认选中数据
     */
    async handleSkuClick(item, index1, index2, eventFalse) {
      if (!eventFalse) {
        if (this.groupBuyMark) {
          let page_name = '';
          if (this.ptFlagProp === 2) {
            page_name = '参团页';
          } else if (this.ptFlagProp === 1) {
            page_name = '拼团商品详情页';
          } else if (this.ptFlag === 1) {
            page_name = '拼团商品详情页';
          }
          if (index1 === 0) {
            this.setTrack(
              { module_name: 'sku选择模块', page_name: page_name, item_name: '选择年级', main_item_type: '拼团', btn_name: item.specilName, ...this.ptMaidian },
              'click'
            );
          }
          if (index1 === 1) {
            this.setTrack(
              { module_name: 'sku选择模块', page_name: page_name, item_name: '选择开课时间', main_item_type: '拼团', btn_name: item.specilName, ...this.ptMaidian },
              'click'
            );
          }
        } else {
          this.setTrack(
            { module_name: '浮层', item_name: '选择规格', btn_name: '规格按钮' },
            'click'
          );
        }
      }

      let {
        detail: {
          specilMapping,
          stockReminderNum,
          stockReminderContent,
          downSpecil,
        },
      } = this;

      // 处理选中状态
      // 1-所处的规格列表拎出来
      let thisSpecilArr = this.skuRenderArr[index1].specilArr;

      thisSpecilArr = thisSpecilArr.map((item, index) => {
        item.selected = index2 === index;
        return item;
      });

      // 双规格-上规格
      if (index1 === 0 && this.ifDoubleSku && index2 !== this.upIndex) {
        this.$set(this.skuRenderArr[1], 'isModuleShow', true);
        this.downIndex = -1;
        // 下规格数组列表
        let thisSpecilArr = this.skuRenderArr[1].specilArr;
        thisSpecilArr = thisSpecilArr.map((item, index) => {
          item.selected = false;
          return item;
        });
      }

      // 生成sku key => keysStr， 上规格有值
      if (index1 === 0) {
        if (index2 !== this.upIndex) {
          this.downStr = '';
        }
        if (downSpecil.length > 0) {
          let upSpecilId = this.skuRenderArr[index1].specilArr[index2].specilId;
          let downSpecilIdArr = [];
          specilMapping.map((item) => {
            let selectmaping;
            let keyArr = item.key.split('-');
            if (item.stockNum < 1 && keyArr.includes(upSpecilId)) {
              downSpecilIdArr.push(keyArr[1]);
            }
            if (item.key.includes(upSpecilId)) {
              let realStock = '';
              selectmaping = item;
              let arr = selectmaping.key.split('-');
              let downId = arr[1];
              let { fakeStockNum, fakeStockValid, stockNum } = selectmaping;
              if (fakeStockValid) {
                realStock
                  = fakeStockNum <= stockReminderNum ? fakeStockNum : '';
              } else {
                realStock = stockNum <= stockReminderNum ? stockNum : '';
              }
              let downIndex;
              downSpecil.map((item2, index2) => {
                if (item2.specilId === downId) {
                  downIndex = index2;
                }
              });
              if (realStock !== '') {
                realStock = stockReminderContent.replace(/%s/g, realStock);
              }
              this.skuRenderArr[1].specilArr[downIndex].stockTips = realStock;
            }
          });
          let realIndex = -1;
          this.skuRenderArr[1].specilArr.map((item) => {
            let downSpecilId = item.specilId;
            let newKeyStr = upSpecilId + '-' + downSpecilId + '-';
            let a = specilMapping.find((item2) => item2.key === newKeyStr);
            if (!a) {
              item.display = false;
            } else {
              item.display = !downSpecilIdArr.includes(item.specilId);
            }
            if (item.display) {
              item.realIndex = ++realIndex;
            }
          });
        } else {
          specilMapping.map((selectmaping, index) => {
            let realStock = '';
            let { fakeStockNum, fakeStockValid, stockNum } = selectmaping;
            if (fakeStockValid) {
              realStock = fakeStockNum <= stockReminderNum ? fakeStockNum : '';
            } else {
              realStock = stockNum <= stockReminderNum ? stockNum : '';
            }
            if (realStock !== '') {
              realStock = stockReminderContent.replace(/%s/g, realStock);
            }
            this.skuRenderArr[0].specilArr.map((up, upIndex) => {
              if (selectmaping.key.includes(up.specilId)) {
                this.skuRenderArr[0].specilArr[upIndex].stockTips = realStock;
              }
            });
          });
        }

        this.upIndex = index2;
        this.upStr = item.specilId + '-';
        this.upSpecilId = item.specilId;
        this.upspecilName = item.specilName;
        // 切换上规格时，切换到其选中过的下规格
        if (this.detail.skuSwitch) {
          this.handleRecordSpecil(item.specilId);
        }
      } else {
        this.downIndex = index2;
        this.downStr = item.specilId + '-';
        this.downSpecilId = item.specilId;
        this.downspecilName = item.specilName;
        this.updateRecordSpecil(item.specilId);
      }
      this.keysStr = this.upStr + this.downStr;

      // mapping 匹配到的库存item
      let selectmaping = specilMapping.find(
        (item) => item.key === this.keysStr
      );
      this.selectmaping = selectmaping;
      if (this.selectmaping && !this.detail.couponUse && this.detail.skuCouponMapping && this.detail.skuCouponMapping[this.selectmaping.skuId] && this.detail.skuCouponMapping[this.selectmaping.skuId].discountPrice && this.detail.showCouponPrice || this.detail.reduceFlag) {
        this.couponUseMark = true;
      } else {
        this.couponUseMark = false;
      }

      // 获取优惠描述
      const { skuId } = this.selectmaping || {};
      if (skuId && this.detail.skuCouponMapping && this.detail.skuCouponMapping[skuId]) {
        this.couponUseText = this.detail.skuCouponMapping[skuId]?.couponUseText;
      } else {
        this.couponUseText = '';
      }

      // 两个级别规格 判断keysStr有两个 -
      let a1 = this.keysStr.match(new RegExp(/-/g)).length === 2;

      // 单一级别规格 判断keysStr有一个 - ，而且downSpecil是空数组
      let a2
        = this.keysStr.match(new RegExp(/-/g)).length === 1
        && this.detail.downSpecil.length === 0;

      if (a1) {
        this.stockNum = selectmaping.stockNum;
        this.$emit('upDownOk', selectmaping.key);
      }
      if (a2) {
        this.$emit('upDownOk', selectmaping.key);
        this.stockNum = selectmaping.stockNum;
      }

      // 实物商品获取限购数量
      if (this.isPhysicalGoods) {
        await this._getBuyNum();
      }

      if (this.numCount > this.limitNum.stockNum) {
        this.numCount = this.limitNum.stockNum == 0 ? 1 : this.limitNum.stockNum;
      }

      this.handleRealPrice(index2);

      // 实物商品时，记录规格顺序
      if (this.isPhysicalGoods && index1 === 0) {
        this.updateGoodsCover(item, index1, index2);
      }
    },
    closeHandle() {
      this.$emit('update:show', false);
      if (this.groupBuyMark && (this.ptFlagProp === 2 || this.ptFlag == 2)) {
        this.setTrack(
          { module_name: 'sku选择模块', page_name: '拼团商品详情页', main_item_type: '拼团', btn_name: '关闭', ...this.ptMaidian },
          'click'
        );
      } else if (this.detail.couponUse && !this.activityId) {
        this.setTrack({ page_name: '商城领券购详情页', module_name: 'sku选择浮层', btn_name: '关闭' }, 'click');
      }
    },
    // 新增onClose点击时间是为了区分点击关闭和van-popup的close监听, 防止埋点重复上报
    onClose() {
      this.closeHandle();
      // 单报新增买点
      let sku = this.disabled ? '' : this.selectmaping.skuId;
      this.$parent && this.$parent.setLogTrack && this.$parent.setLogTrack({ module_name: 'sku选择浮层', btn_name: '关闭', key1: { sku: sku } }, 'click');
    },
    setPrice(price, index) {
      price = '' + price;
      price = price.split('.')[index];
      return price;
    },
    async addHandle(ops) {
      if (this.disabled) {
        this.$coolToast({
          text: '请选择正确的规格!',
          time: 1000
        });
        return;
      }
      if (this.groupBuyMark && (this.ptFlagProp === 2 || this.ptFlag == 2)) {
        this.setTrack({ module_name: 'sku选择模块', page_name: '参团页', main_item_type: '拼团', btn_name: '拼团购买', ...this.ptMaidian }, 'click');
      } else if (this.detail.couponUse && !this.activityId) {
        this.setTrack({ page_name: '商城领券购详情页', module_name: 'sku选择浮层', btn_name: '立即购买', grade: this.upspecilName, Time_period: this.downspecilName }, 'click');
      } else {
        this.setTrack({ module_name: '浮层', item_name: '选择规格', btn_name: '立即购买' }, 'click');
      }

      // 单报新增买点：立即购买
      if (ops?.jump != 'auto') {
        this.$parent && this.$parent.setLogTrack && this.$parent.setLogTrack({ module_name: '规格确认', btn_name: '确认', key1: { sku_id: this.selectmaping.skuId, goods_id: this.itemid, from: 2 } }, 'click');
      }

      if (this.currentCourse.stockNum === 0) {
        return false;
      }

      // 判断拼团的登陆状态, 如果为登陆，先登陆
      if (this.ptFlag && !this.userReallyOnline && this.$route.name === 'courseItem') {
        this.$emit('onLogin', { group_buy: this.groupBuyMark });
        return;
      }

      // 如果是否是简化0元领取流程，未登录，走半屏登陆
      if (!this.userReallyOnline && this.$route.name === 'courseItem' && (this.isSimpleProcess || this.detail.goodsType == 7)) {
        this.$emit('onLogin', {});
        return;
      }

      // 如果是否是简化0元领取流程，登录，直接下单
      if (this.userReallyOnline && this.$route.name === 'courseItem' && this.isSimpleProcess) {
        this.$emit('onPlaceOrder', {
          upSpecilId: this.upSpecilId,
          downSpecilId: this.downSpecilId,
          skuId: this.selectmaping.skuId,
          keysStr: this.keysStr,
          upspecilName: this.upspecilName,
          downspecilName: this.downspecilName,
        });
        return;
      }


      // 实物商品，跳转结算台之前校验购买数量是否限购
      if (this.isPhysicalGoods) {
        await this._getBuyNum();
        if (this.numCount > this.limitNum.stockNum || this.limitNum.stockNum == 0) {
          this.limitToast(this.limitNum.stockNum, this.limitNum.type);
          return;
        }
      }

      let query = '&';
      for (let key in this.otherQuery) {
        if (key == 'ptFlag') {
          if (this.groupBuyMark) {
            if (this.ptFlagProp) {
              query += `${key}=${this.ptFlagProp}&`;
            } else {
              query += `${key}=${this.otherQuery[key]}&`;
            }
          }
        } else if (key == 'groupSn') {
          if (this.groupBuyMark) {
            query += `${key}=${this.otherQuery[key]}&`;
          }
        } else {
          query += `${key}=${this.otherQuery[key]}&`;
        }
      }

      // @aigc:start 2024/11/28-18:55
      // 如果在开参团中使用，地址中如果没有proxyId、proxyUid，则需要添加
      if (this.groupBuyMark && !query.includes('proxyId') && this.proxyInfo && this.proxyInfo.proxyUid) {
        query += `proxyId=${this.proxyInfo.proxyId}&proxyUid=${this.proxyInfo.proxyUid}&`;
      }
      // @aigc:end 2024/11/28-18:55

      query = query.substr(0, query.length - 1);
      let { recommendFlag } = this.detail;
      let {
        upSpecilId,
        downSpecilId,
        itemid,
        keysStr,
        selectmaping,
        upspecilName,
        downspecilName,
      } = this;

      let paramsObj;
      if (this.detail.sellType === 5) {
        paramsObj = {
          up_specil_id: upSpecilId,
          down_specil_id: downSpecilId,
          itemid: itemid,
          sellType: this.detail.sellType
        };
      } else {
        paramsObj = {
          up_specil_id: upSpecilId,
          down_specil_id: downSpecilId,
          itemid: itemid,
          key: keysStr,
          skuid: selectmaping.skuId
        };
        if (!this.groupBuyMark) {
          paramsObj.upspecilName = upspecilName;
          paramsObj.downspecilName = downspecilName;
        }
      }
      if (this.groupBuyMark) {
        paramsObj.selectedPtLadder = this.selectedPtLadder.idStr;
        paramsObj.actualPrice = parseFloat(`${this.realPrice.actualPrice[0]}.${this.realPrice.actualPrice[1]}`);
      }
      if (this.fqBuyMark) {
        paramsObj.fqFlag = 1;
      }
      if (this.isPhysicalGoods) {
        paramsObj.physicalNum = this.numCount;
      }
      let paramsStr = '';
      for (let k in paramsObj) {
        if (paramsObj[k] !== undefined && paramsObj[k] !== null) {
          paramsStr += `${k}=${paramsObj[k]}&`;
        }
      }
      paramsStr = paramsStr.substring(0, paramsStr.length - 1);
      paramsStr += query;

      // 确定url
      let url;
      if (this.buyType === 'singBuy') {

        if (this.detail.sellType === 5) {
          url = `/h5Pay/mall_training_camp_order?${paramsStr}`;
          let isInDouyinApp = isDouyinApp();
          if (isInDouyinApp) {
            douyinAuth().then(res => {
              // ISession('authInfo', JSON.stringify(res.data));
              setUser(JSON.stringify(res.data));
              this.$router.push(url);
            }).catch(err => {
              this.$router.push(url);
            });
          } else if (isInBaiduBrowser) {
            // 百度浏览器中，个别安卓手机在收银台获取到的地址是入口地址（商品详情地址），造成支付成功后返回商品详情页面，打断了支付流程，所以在微博中用window.location.href跳转
            window.location.href = `${window.location.origin}${url}`;
          } else if (env.isApp) {
            // 由于性能优化，APP内需要使用鲁班系统，到结算台页面需要刷新路由地址，因此APP内跳转更改为使用JS2Native
            JS2Native({
              name: 'navigateTo',
              params: {
                router: 'igetcool://juvenile.dedao.app/go/h5?params_url=' + encodeURIComponent(window.location.origin + url)
              }
            });
          }  else {
            this.$router.push(url);
          }
          return;
        }
        if (this.userReallyOnline) {
          let index = paramsStr.indexOf('preset_up_specil_id');
          if (index > -1) {
            paramsStr = paramsStr.substring(0, index - 1);
          }
          url = (recommendFlag && !this.groupBuyMark)
            ? `/mall/recommendCourse?${paramsStr}`
            : `/h5Pay/mall_order?${paramsStr}`;
        } else {
          // 登陆页埋点使用， 用来判断是否是领券购、流程类型
          !paramsStr.includes('sellType') && (paramsStr += '&sellType=' + this.detail.sellType);
          !paramsStr.includes('couponUse') && (paramsStr += '&couponUse=' + (this.detail.couponUse ? 1 : 0));
          this.$router.push({ path: `/mall/get_recommend_flag?${paramsStr}` });
          return;
        }

        if (isInBaiduBrowser) {
          location.href = url;
        } else if (env.isApp) {
          // 由于性能优化，APP内需要使用鲁班系统，到结算台页面需要刷新路由地址，因此更改APP内跳转更改为使用JS2Native
          JS2Native({
            name: 'navigateTo',
            params: {
              router: 'igetcool://juvenile.dedao.app/go/h5?params_url=' + encodeURIComponent(window.location.origin + url)
            }
          });
        } else {
          this.$router.push(url);
        }
      } else if (this.buyType === 'combineBuy') {
        this.$emit('combineBuy', {
          skuid: selectmaping.skuId,
        });
      }
    },

    setTrack(options = {}, type = 'show') {
      let oldOP = {
        page_name: '商城详情页',
        page_type: 2,
        page_title: document.title,
        url: location.href,
        main_item_id: this.itemid,
        mall_channel: this.igc_from,
      };
      let newOP = Object.assign({}, oldOP, options);
      LogTrack.track(newOP, type);
    },

    // 登陆成功后调用，自动跳转到收银台
    handleJumpClick() {
      // 重新计算价格
      this.handleRealPrice();
      // 确定购买（跳转到收银台） jump: 表示自动调用，不是手动点击
      this.addHandle({ jump: true });
    },

    // 切换选择过的下规格
    handleRecordSpecil(upSpecilId) {
      // 没有下规格，不处理
      if (!this.ifDoubleSku) {
        return;
      }
      // 获取选中过的下规格
      let downSpecilId = this.getRecordSpecil(upSpecilId);
      if (!downSpecilId) {
        // 找到起对应的最大库存的dowmSpecilId
        let max = 0;
        this.detail.specilMapping.forEach((item) => {
          let first_key = item.key.split('-')?.[0];
          if (upSpecilId === first_key && item.stockNum >= max) {
            max = item.stockNum;
            downSpecilId = item.key.split('-')?.[1];
          }
        });
      }
      // 找到下规格对应的位置，手动点击
      const downTenderArr = this.skuRenderArr?.[1]?.specilArr;
      downTenderArr.map((item, index) => {
        if (item.specilId === downSpecilId) {
          this.handleSkuClick(item, 1, index, true);
        }
      });
    },
    // 更新历史记录
    updateRecordSpecil(downSpecilId) {
      this.specilHistoryObj[this.upSpecilId] = downSpecilId;
    },
    // 获取历史记录
    getRecordSpecil() {
      return this.specilHistoryObj[this.upSpecilId] || '';
    },

    // 滑动图片时，切换规格
    updateGoodsCoverUrl(current) {
      const index = this.goodsCovers.findIndex(item => item === this.courseImg);
      if (current === index || current < 1) {
        return;
      }
      let begin = current > 0 ? current - 1 : 0;
      let specil = this.skuRenderArr[0].specilArr[begin];
      this.handleSkuClick(specil, 0, begin);
    },
    // 更换商品图片
    updateGoodsCover(item, index1, index2) {
      this.currentCourseImg = item.coverImg;
    },
    // 查看图片
    handleShowImage() {
      // 非实物商品没有图片预览功能
      if (!this.isPhysicalGoods) {
        return;
      }
      const index = this.goodsCovers.findIndex(item => item === this.courseImg);
      // if (env.isWeChat) {
      //   WeixinJSBridge.invoke('imagePreview', {
      //     'urls': this.goodsCovers,
      //     current: this.courseImg,
      //   });
      // } else {
      const that = this;
      ImagePreview({
        images: this.goodsCovers,
        showIndex: false,
        closeable: true,
        loop: false,
        startPosition: index,
        onChange: (i) => {
          this.updateGoodsCoverUrl(i);
        }
      });
      // }
    },

    // 通过skuId获取限购数量
    _getBuyNum() {
      return new Promise(async (resolve) => {
        const { uid } = JSON.parse(getUser()) || {};
        let data = await getBuyNum({ uid: uid, goodsSkuId: this.selectmaping.skuId });
        this.limitNum = data.data || {};
        resolve(data.data);
      });
    },

    limitToast(stockNum, type) {
      let toastMes = `库存不足，最多只能购买${stockNum}件。`;
      if (stockNum == 0) {
        toastMes = `此商品购买已超限！`;
      } else if (type == 2) {
        toastMes = `此商品限购${stockNum}件，无法添加更多。`;
      }
      this.$coolToast({
        text: toastMes,
        time: 1500
      });
    },

    // 数量加 +
    numAdd() {
      if (this.disabled) {
        this.$coolToast({
          text: '请选择正确的规格!',
          time: 1000
        });
        return;
      }

      if (this.limitNum.stockNum == this.numCount || this.limitNum.stockNum == 0 || this.limitNum.stockNum < this.numCount) {
        this.limitToast(this.limitNum.stockNum, this.limitNum.type);
        return;
      }
      this.numCount++;
    },
    // 数量减
    numMinus() {
      if (this.disabled) {
        this.$coolToast({
          text: '请选择正确的规格!',
          time: 1000
        });
        return;
      }
      if (this.numCount === 1) {
        this.$coolToast({
          text: '这已经是最小购买数量了，无法再减少。',
          time: 1000
        });
        return;
      }
      this.numCount--;
    },

    // 输入框点击
    inputNumClick(num) {
      if (this.disabled) {
        this.$coolToast({
          text: '请选择正确的规格!',
          time: 1000
        });
        return;
      }
      if (this.isOutSale) {
        this.$coolToast({
          text: '此商品购买已超限！',
          time: 1000
        });
        return;
      }
      this.inputPopNum = this.numCount;
      this.inputNumShow = true;
    },
    inputNumClose() {
      this.inputNumShow = false;
    },
    // 确认输入数量
    numConfirm(val) {
      this.inputNumClose();
      if (val < 1) {
        val = 1;
      }
      let num = Math.round(val);
      if (num > this.limitNum.stockNum) {
        this.limitToast(this.limitNum.stockNum, this.limitNum.type);
        // 超出限制使用最大值
        if (this.limitNum.stockNum !== 0) {
          this.numCount = this.limitNum.stockNum;
        }
        // 每一次
        this.inputPopNum = 0;
        return;
      }
      this.numCount = num;
    }
  },
  components: {
    IDelTag,
    IButton,
    SafeArea,
    numCounter,
    NumChange
  },
};
</script>

<style scoped lang="stylus">
@import '~@/assets/styles/var.styl';

::-webkit-scrollbar {
  width: 0;
}

.shop_car_container {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  z-index: 999;


  .shop_car_content {
    box-sizing: border-box;
    background-color: $white;
    padding: 20px 19px;
    z-index: 1000;
    overflow-y: auto;
    position: relative;

    .product-info {
      width: 335px;
      height: 90px;
      display: flex;
      position: absolute;
      top: 20px;
      justify-content: space-between;

      .product-img {
        width: 66px;
        height: 87px;
        border-radius: 6px;
        flex-shrink: 0;
      }

      .intro-wrap {
        margin-left: 12px;

        .title {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: rgba(65, 65, 77, 1);
          line-height: 22px;
          font-weight: bold;
        }

        .desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(65, 65, 77, 1);
          line-height: 16px;
          margin-top: 5px;
        }
      }

      .del_wrap_out {
        margin-left: auto;
        margin-right: 0;
      }
    }

    .sku-wrap {
      max-height: 55vh;
      overflow: auto;
      margin-top: 90px;
      margin-bottom: 96px;

      .sku-outeritem-wrap {
        .sku-title {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: bold;
          color: rgba(109, 109, 128, 1);
          line-height: 20px;
          margin-bottom: 12px;
          margin-top: 14px;
        }

        .sku-title2 {
          margin-top: 16px;
          margin-bottom: 20px;
        }
      }

      .sku-inneritem-wrap {
        &.sku-inneritem-wrap--phy {
          // 实物商品规格样式
          .item2-wrap {
            margin-bottom: 12px;
          }
          .item-wrap {
            display: flex;
            align-items: center;
            padding: 0 6px;
            border-radius: 6px;
            background: #F8F8FA;
            &.item-wrap--selected {
              background: rgba(255,95,46,0.07);
              .item-name.selected {
                background: none;
              }
            }

            .item-name {
              text-align: left;
              flex: 1;
            }
          }

          .item-wrap__cover {
            width: 23px;
            height: 30px;
          }
          .item-wrap__cover-img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 3px;
          }
        }
        .sku-inner-item {
          min-width: 158px;
          float: left;

          .item-name {
            padding: 10px 11px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(65, 65, 77, 1);
            line-height: 16px;
            border-radius: 10px;
            background: rgba(248, 248, 250, 1);
            text-align: center;

            &.selected {
              background: rgba(255, 95, 46, 0.07);
              font-weight: 600;
              color: rgba(255, 95, 46, 1);
            }
          }

          .item-stock {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 17px;
            color: #41414d;

            &.selected {
              color: #ff5f2e;
              font-weight: 600;
            }
          }
        }
      }
    }

    .physical-num {
      margin 18px 0 25px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 10px;
      span {
        color #6D6D80;
        font-size: 14px;
      }
    }

    .sku-wrap {
      .item-wrap {
        margin-bottom: 12px;
        margin-right: 9px;
      }

      .item2-wrap {
        margin-bottom: 20px;
        position: relative;

        .stock-bg {
          position: absolute;
          top: -10px;
          right: 0px;
          min-width: 80px;
          height: 20px;
          padding: 0 5px
          color: #F5554A;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-size: 100% 100% !important;

          &.selected {
            color: #fff;
          }
        }
      }
    }

    .sku-wrap-nodata {
      height: 133px;
      margin-bottom: 0;
      line-height: 99px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #A1A1B3;
    }
    .pre_top_line{
        width: 37.5rem;
        margin-right:-1rem;
        margin-left:-1rem;
        height: 0.05rem;
        background: #F5F5FA;
        margin-bottom:.05rem;
    }
    .footer-wrap {
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: 0;
      width: 335px;
      background-color: #ffffff;

      .top_line{
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        height: auto;
        span{
          background: #f8f8fa;
          margin-top:.05rem;
          margin-right: 19px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 0.98rem;
          height: .36rem;
          font-size: .12rem;
          color: #41414d;
          border-radius: .1rem;

          &:nth-child(3n), &:last-child{
            margin-right: 0;
          }
        }
      }
      .middle_line {
        margin: .1rem auto 0;
        width: 100%;
        height: 0.01rem;
        background: #F5F5FA;
      }
      .bottom_line{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        padding-top: 10px;
        .price-wrap {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .actual-price {
            display: flex;
            align-items: flex-end;
            color: #FF5F2E;

            span.group-buy-tip {
              height: 18px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #41414D;
              line-height: 18px;
            }

            span.icon {
              font-size: 14px;
              font-weight: 700;
              line-height: 14px;
            }

            span.price {
              line-height: 20px;
              font-size: 20px;
              font-family: Oswald-Medium;

              &.small {
                line-height: 14px;
                font-size: 14px;
              }
            }
          }

          .original-price {
            text-decoration: line-through;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(161, 161, 179, 1);
            margin-left: 6px;
          }
        }
      }
    }
  }
}

.clearfix:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
</style>
